export var GamePOIType;
(function (GamePOIType) {
    GamePOIType["Start"] = "start";
    GamePOIType["Finish"] = "finish";
    GamePOIType["Generic"] = "generic";
})(GamePOIType || (GamePOIType = {}));
//# sourceMappingURL=game-poi-type.enum.js.map